/* Shopify's native form and rendered context are the authority, even without modules or storage. */
(function () {
  var root = document.querySelector('[data-hdt-localization]');
  if (!root) return;
  var country = document.getElementById('HdtFallbackCountry');
  var language = document.getElementById('HdtFallbackLanguage');
  var syncLanguages = function () {
    if (!country || !language) return;
    var available = (country.options[country.selectedIndex].getAttribute('data-country-languages') || '').split(',');
    Array.prototype.forEach.call(language.options, function (option) {
      option.disabled = available.indexOf(option.value) === -1;
    });
    if (language.selectedOptions[0] && language.selectedOptions[0].disabled) {
      var first = Array.prototype.find.call(language.options, function (option) { return !option.disabled; });
      if (first) language.value = first.value;
    }
  };
  if (country) country.addEventListener('change', syncLanguages);
  syncLanguages();

  // Verify the result on the next page without depending on session/local storage.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !form) return;
    var action;
    try { action = new URL(form.getAttribute('action'), window.location.origin); } catch (error) { return; }
    if (action.origin !== window.location.origin || !/^\/(?:[^/]+\/)?localization\/?$/.test(action.pathname)) return;
    var selectedCountry = form.querySelector('[name="country_code"]');
    var selectedLanguage = form.querySelector('[name="language_code"]');
    var returnTo = form.querySelector('[name="return_to"]');
    if (!selectedCountry || !selectedLanguage || !returnTo) return;
    var destination = new URL(returnTo.value || window.location.pathname, window.location.origin);
    if (destination.origin !== window.location.origin) return;
    destination.searchParams.set('hdt_country', selectedCountry.value);
    destination.searchParams.set('hdt_language', selectedLanguage.value);
    if (window.Shopify && window.Shopify.previewMode === true && !window.Shopify.designMode
        && window.Shopify.theme && window.Shopify.theme.role === 'main') {
      destination.searchParams.set('preview_theme_id', '');
    }
    returnTo.value = destination.pathname + destination.search + destination.hash;
  });

  var url = new URL(window.location.href);
  var checkoutCountry = url.searchParams.get('hdt_checkout_country');
  var targetCountry = url.searchParams.get('hdt_country') || checkoutCountry;
  var targetLanguage = url.searchParams.get('hdt_language');
  var config;
  try { config = JSON.parse(root.querySelector('[data-hdt-localization-config]').textContent); } catch (error) { config = {}; }
  var applied = (!targetCountry || String(targetCountry).toUpperCase() === String(config.currentCountry).toUpperCase())
    && (!targetLanguage || String(targetLanguage).toLowerCase() === String(config.currentLanguage).toLowerCase())
    && Boolean(config.currentCountryCurrency)
    && config.currentCountryCurrency === config.cartCurrency;
  if (!applied && config.currentCountry && config.currentCountryCurrency && config.cartCurrency
      && window.Shopify && window.Shopify.previewMode === true && !window.Shopify.designMode) {
    var previewExit = new URL(url.href);
    ['hdt_country', 'hdt_language', 'hdt_checkout_country'].forEach(function (key) { previewExit.searchParams.delete(key); });
    previewExit.searchParams.set('preview_theme_id', '');
    if (previewExit.hash === '#HdtLocalizationFallback') previewExit.hash = '';
    root.querySelectorAll('[data-localization-preview-warning]').forEach(function (warning) {
      var link = warning.querySelector('[data-localization-exit-preview]');
      if (!link) return;
      link.href = previewExit.pathname + previewExit.search + previewExit.hash;
      warning.hidden = false;
    });
  }
  if (!targetCountry) return;
  ['hdt_country', 'hdt_language', 'hdt_checkout_country'].forEach(function (key) { url.searchParams.delete(key); });
  if (!applied) url.hash = 'HdtLocalizationFallback';
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  if (!applied) {
    var status = root.querySelector('[data-localization-result]');
    if (status) { status.hidden = false; status.textContent = status.getAttribute('data-failed-text'); }
    var fallback = document.getElementById('HdtLocalizationFallback');
    if (fallback) { fallback.scrollIntoView({ block: 'center' }); fallback.focus(); }
    return;
  }
  if (checkoutCountry && String(checkoutCountry).toUpperCase() === String(config.currentCountry).toUpperCase()
      && Number(root.getAttribute('data-cart-count')) > 0) {
    window.location.replace(root.getAttribute('data-checkout-url'));
  }
})();
